import { jsx as _jsx } from "react/jsx-runtime";
import { NinDisplay } from "components/Common/NinDisplay";
import { useAppSelector } from "eduid-hooks";
import { NinForm } from "./NinForm";
export function AddNin() {
    const nin = useAppSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.personal_data) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.identities) === null || _c === void 0 ? void 0 : _c.nin; });
    if (nin) {
        return _jsx(NinDisplay, { nin: nin, allowDelete: true });
    }
    return _jsx(NinForm, {});
}
